import React, { useState, useEffect } from "react";
import axiosClient from "../../../services/axiosClient";
import classNames from "classnames/bind";
import ModalSetting from "./ModalSetting";
import {
  Pagination,
  Loading,
  Alert,
  Toast,
} from "../../../components";
import { cameraManagement } from "../../../services/api/cameraManagementApi";
import TableCamera from "./TableCamera";

import styles from "./Camera.module.css";
import ModalMoreInfo from "./ModalMoreDetail";
import Filter from "./Filter";
import { changeDataCam } from "../../../utils";
import { useLocation, useNavigate } from "react-router-dom";
import ModalLive from "./ModalLive/ModalLive";
import { useStoreContext } from "../../../hooks/useStoreContext";
import { setFilterCamera } from "../../../store/Actions";
const cx = classNames.bind(styles);

const Camera = () => {
  const [isModalInfo, setIsModalInfo] = useState(false);
  const [code, setCode] = useState("");
  const [isRefresh, setIsRefresh] = useState(false);
  const [loading, setLoading] = useState();
  const [data, setData] = useState([]);
  const [isAlert, setIsAlert] = useState();
  const [id, setId] = useState();
  const [pages, setPages] = useState(1);
  const ref = React.useRef(null);
  const [showModalMore, setShowModalMore] = useState(false);
  const [dataMore, setDataMore] = useState({ data: [], type: '' });
  const [infoCurrentCamera, setInfoCurrentCamera] = useState();
  const [showLive, setShowLive] = useState(false);
  const [dataStore, dispatch] = useStoreContext();
  let { state } = useLocation();
  const navigate = useNavigate();
  // eslint-disable-next-line
  const showModal = (id) => {
    setIsModalInfo(true);
    setCode(id);
  };
  useEffect(() => {
    setLoading(true);
    const filter = dataStore.filterCamera;
    let activeCode = state && state !== 'all' ? Number(state) : filter.status;
    async function getData() {
      let pram = {
        page: filter.currentPage,
        size: 10,
        province_code: filter.address === 'all' ? null : filter.address,
        status_active: activeCode === 'all' ? null : activeCode === 1 ? `["1","2"]` : `["${activeCode}"]`,
        camera_name: filter.cameraName,
        company_code: filter.company === 'all' ? null : filter.company,
      };
      try {
        const res = await axiosClient.get(`cameraManagement/get-list-camera/`, {
          params: { ...pram },
        });
        const data = changeDataCam(res)
        setData(data);
        setLoading(false);
        if (data.count > 0) {
          setPages(Math.ceil(data.count / 10));
        } else {
          setPages(1)
        }
      } catch (error) {
        setLoading(false);
        setData({ total: 0, data: [] })
        if (error?.response?.status === 403) {
          Toast.open("Bạn không có quyền xem danh sách camera", "danger");
        }
      }
    }
    // const x = setInterval(() => {
    //   getData();
    // }, 5 * 10000)

    getData();
    // return () => clearInterval(x)
  }, [
    isRefresh,
    state,
    dataStore.filterCamera
  ]);

  const getCameraInfo = async (code) => {
    try {
      const res = await axiosClient.get(`cameraManagement/get-camera-info-by-code/?camera_code=${code}`);
      return res
    } catch (error) {
      Toast.open('Bạn không có quyền quản trị camera', 'danger')
    }
  };
  useEffect(() => {
    const checkCameraInfo = async () => {
      try {
        const cameraInfo = await getCameraInfo(code)
        if (cameraInfo && cameraInfo.length > 0) {
          const cameraChoose = cameraInfo[0];
          const listCamera = data.data;
          const infoCamera = listCamera.filter((item) => item.CAMERA.CODE === cameraChoose.CODE)
          setInfoCurrentCamera([cameraChoose])
        }
      } catch (error) {
        setLoading(false)
      }
    }
    if (code && code.length > 0) {
      checkCameraInfo()
    }
  }, [data, code])
  const handleClick = (page) => {
    const fillter = {
      ...dataStore.filterCamera,
      currentPage: page,
      triger: 'added'
    }
    dispatch(setFilterCamera(fillter))
  };
  const handleNext = () => {
    const fillter = {
      ...dataStore.filterCamera,
      currentPage: dataStore.filterCamera.currentPage + 1,
      triger: 'added'
    }
    dispatch(setFilterCamera(fillter))
  };
  const handlePrevious = () => {
    const fillter = {
      ...dataStore.filterCamera,
      currentPage: dataStore.filterCamera.currentPage - 1,
      triger: 'added'
    }
    dispatch(setFilterCamera(fillter))
  };
  const handleCloseSetting = () => {
    setIsModalInfo(false);
  };
  const onChangeStatus = (status) => {
    const fillter = {
      ...dataStore.filterCamera,
      status: status,
      currentPage: 1,
      triger: 'added'
    }
    dispatch(setFilterCamera(fillter))
    if (state) {
      navigate('/admin/camera', { state: null })
    }
  };
  const onChangeAddress = (data) => {
    const fillter = {
      ...dataStore.filterCamera,
      address: data,
      currentPage: 1,
      triger: 'added'
    }
    dispatch(setFilterCamera(fillter))
  };
  const onChangeCompany = (data) => {
    const fillter = {
      ...dataStore.filterCamera,
      company: data,
      currentPage: 1,
      triger: 'added'
    }
    dispatch(setFilterCamera(fillter))
  }
  const onChangeTextSearch = (e) => {
    const data = e.target.value;
    const fillter = {
      ...dataStore.filterCamera,
      cameraName: data,
      currentPage: 1,
      triger: 'added'
    }
    dispatch(setFilterCamera(fillter))
  };
  const showAlert = (id) => {
    setIsAlert(true);
    setId(id);
  };
  const handleOk = async () => {
    try {
      let listCam = data.data;
      let camera = listCam.find((item) => item.CAMERA.CODE === id)
      if (camera && camera.CAMERA.STATUS_ACTIVE !== 3) {
        await cameraManagement.stopStreaming({
          camera_id: id,
          delete_config_record: 1,
        });
        await cameraManagement.update(
          { camera_status: "Off" },
          id
        );
      }
      const res = await cameraManagement.delete(id);
      if (res.result) {
        Toast.open("Xóa camera thành công", "success");
        setIsAlert(false);
        setIsRefresh(!isRefresh);
      }
    } catch (e) {
      setLoading(false);
      if (e.response.status === 403) {
        Toast.open("Bạn không có quyền xóa camera", "danger");
      } else {
        Toast.open("Xóa camera không thành công", "danger");
      }
    }
  };

  const getDataShowMore = (data, type) => {
    setShowModalMore(!showModalMore)
    setDataMore({ data: data, type: type })
  }

  const onCloseModalLive = (code_cam) => {
    setShowLive(!showLive);
    setCode(code_cam)
  }
  return (
    <>
      <div id="__notification"></div>
      {isAlert && (
        <Alert
          type="alert"
          title="Bạn có muốn xóa ko"
          onClose={(e) => setIsAlert(false)}
          onOk={handleOk}
        />
      )}
      <div className={cx("header")}>
        <h1 className={cx("title")}>Quản trị camera</h1>
      </div>
      <div className={cx("content")}>
        <Filter
          input={dataStore.filterCamera.cameraName}
          onChangeAddress={onChangeAddress}
          onChangeStatus={onChangeStatus}
          onChangeTextSearch={onChangeTextSearch}
          onChangeCompany={onChangeCompany}
        />
        {!loading ? (
          <>
            <TableCamera
              data={data.data}
              showAlert={showAlert}
              showModal={showModal}
              showModalMore={(data, type) => getDataShowMore(data, type)}
              showStream={onCloseModalLive}
            />
            {data?.data?.length > 0 && (
              <div className={cx("pagination")}>
                <Pagination
                  onClick={handleClick}
                  onNext={handleNext}
                  onPrevious={handlePrevious}
                  currentPage={dataStore.filterCamera.currentPage}
                  pages={pages}
                />
              </div>
            )}
          </>
        ) : (
          <div className={cx("loading")}>
            <Loading />
          </div>
        )}
      </div>

      {isModalInfo && infoCurrentCamera && infoCurrentCamera.length > 0 && (
        <ModalSetting
          onclose={handleCloseSetting}
          setIsRefresh={setIsRefresh}
          isRefresh={isRefresh}
          camera={infoCurrentCamera}
          show={isModalInfo}
        />
      )}

      {showModalMore && <ModalMoreInfo showModal={getDataShowMore} data={dataMore} />}
      {showLive && <ModalLive onClose={onCloseModalLive} code_cam={code} />}
    </>
  );
};

export default Camera;
